import * as React from 'react';
import { withTranslation } from 'react-i18next';
import InfoMessagesList from '../infomessages/InfoMessagesList';

function AdminNewsList() {
    return <div>
        <InfoMessagesList isAdminPage={true} />
    </div>;
}

export default withTranslation('translations')(AdminNewsList);
